import { render, staticRenderFns } from "./labelManagement.vue?vue&type=template&id=37c43c71&scoped=true&"
import script from "./labelManagement.vue?vue&type=script&lang=js&"
export * from "./labelManagement.vue?vue&type=script&lang=js&"
import style0 from "./labelManagement.vue?vue&type=style&index=0&id=37c43c71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c43c71",
  null
  
)

export default component.exports